export const INDUSTRY_SECTORS = [
  'Technology',
  'Manufacturing',
  'Energy',
  'Healthcare',
  'Finance',
  'Cement',
  'Automobile',
  'Pharma',
  'Aluminium',
  'Steel',
  'Oil & Gas'
];

export const METRIC_LABELS = {
  scope1: 'Scope 1 Emissions',
  scope2: 'Scope 2 Emissions',
  emissionIntensityPerTurnover: 'Scope 1 & 2 Emission Intensity per Rupee of Turnover',
  treatedWaterDischarged: 'Treated Water Discharged (%)',
  renewableEnergy: 'Renewable Energy (%)',
  wasteRecycled: 'Waste Recycled (%)',
  hazardousWaste: 'Hazardous Waste',
  wasteIntensity: 'Waste Intensity',
  ltirEmployee: 'LTIR - Employees',
  ltirWorker: 'LTIFR - Workers',
  dataPrivacyPolicy: 'Data Privacy Policy',
  disciplinaryAction: 'Disciplinary Actions (Bribery)',
  daysAccountsPayable: 'Days Accounts Payable'
};
